// import 'babel-polyfill';
import React from 'react';
import './index.less';

const noticeTemp = global.ruleUsTemp || '';
const RuleUsTemp = () => (
  <div className="useContainer" dangerouslySetInnerHTML={{ __html: noticeTemp }} />
);
export default RuleUsTemp;
